import React from 'react'
import Container from '@mui/material/Container'
import Typography from '@mui/material/Typography'
import Paper from '@mui/material/Paper'
import Stack from '@mui/material/Stack'

import Form from '~/client/components/Form'
import MySessionsList from '~/client/components/MySessionsList'
import OauthAccounts from '~/client/components/OauthAccounts'

export default function Page({ currentUser }) {
  return <Container sx={{mt: 2}} maxWidth='sm'>
    <Paper sx={{p: 2}}>
      <Typography variant="h4" sx={{mb: 2}}>Sessions</Typography>
      <MySessionsList />
    </Paper>
  </Container>
}
